import { MotionValue, useTransform } from 'framer-motion';
import { PHASE_2_END, TITLE_SCALE_START } from './ecosystem-phases';

export function useEcosystemScroll(scrollYProgress: MotionValue<number>) {
    const titleScale = useTransform(scrollYProgress, [0, PHASE_2_END * 0.5], [1, TITLE_SCALE_START]);
    const trackOpacity = useTransform(scrollYProgress, [0, PHASE_2_END * 0.5], [0.999, 0]);
    const orbitRotateX = useTransform(scrollYProgress, [0, PHASE_2_END * 0.5], [0, 90]);
    const orbitScaleX = useTransform(scrollYProgress, [0, PHASE_2_END * 0.3], [1, 2]);
    const orbitTranslateY = useTransform(scrollYProgress, [0, PHASE_2_END * 0.4], [0, -200]);

    return {
        titleScale,
        trackOpacity,
        orbitRotateX,
        orbitScaleX,
        orbitTranslateY,
    };
}
